import useSWRBase, { SWRConfiguration } from 'swr';

export type TAttachmentMetadata = {
  contentType: string | null;
  contentLength: string | null;
};

const fetcher = async (url: string): Promise<TAttachmentMetadata> => {
  const res = await fetch(url, {
    method: 'HEAD',
  });
  const headers = res.headers;
  return {
    contentType: headers.get('content-type'),
    contentLength: headers.get('content-length'),
  };
};

export const useAttachmentMetadata = (
  url: string,
  metadata?: {
    contentType: string | null;
    contentLength: string | null;
  },
  options?: SWRConfiguration
) => {
  return useSWRBase<TAttachmentMetadata>(
    url,
    () => {
      if (metadata) {
        return metadata;
      }

      return fetcher(url);
    },
    options
  );
};

export const useAttachmentMetadataBulk = (
  urls: string[],
  options?: SWRConfiguration
) => {
  return useSWRBase<TAttachmentMetadata[]>(
    urls,
    () => {
      return Promise.all(urls.map((url) => fetcher(url)));
    },
    options
  );
};
